/**
 * Utilities for working with `npm` (NodeJS) packages.
 * Many of these likely work with packages of other NodeJS
 * package managers and adjacent runtimes (*e.g.*, `bun` or `deno`).
 *
 * @module @sorrell/utilities/npm
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export * from "./Npm.ts";
export * from "./Npm.Error.ts";
